export enum BindUserToAgentKeys {
  uid = 'uid',
  agentDbId = 'agentDbId',
}

export interface BindUserToAgent {
  [BindUserToAgentKeys.uid]: string;
  [BindUserToAgentKeys.agentDbId]: string;
}
